
import { useRoleChecks } from "./use-role-checks";
import { useCountryAccess } from "./use-country-access";
import { UserRole } from "./role-utils";

/**
 * Unified permissions hook that combines role and country access checks
 */
export const usePermissions = () => {
  const roleChecks = useRoleChecks();
  const countryAccess = useCountryAccess();
  
  return {
    ...roleChecks,
    ...countryAccess
  };
};

// Re-export types
export type { UserRole };
